// authConfig.js

// Determine the redirectUri based on the hostname of the current window
const redirectUri = window.location.origin;
console.log(redirectUri);
export const msalConfig = {
  auth: {
    clientId: "f1331b3b-4157-4d5a-9117-22f1ef20289f",
    authority:
      "https://login.microsoftonline.com/56564e0f-83d3-4b52-92e8-a6bb9ea36564",
    redirectUri: redirectUri,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};
